module.exports = __webpack_public_path__ + "img/otros.c28e390d.jpg";